import React from 'react';
import { MapContainer, MapHolder } from './mapStyles';
import StoryPlacesMap from '../../MapComponents/StoryPlacesMap';
import { LatLng } from 'leaflet';
import { PlaceList } from '../../../models/factories/PlaceFactory';
import { Place } from '../../../models/Place';
import { IPlace } from '../../../models/interfaces/IPlace';

type PlacesMapProps = {
	places: IPlace[];
};

const Map: React.FC<PlacesMapProps> = ({ places }: PlacesMapProps) => {
	return (
		<>
			<MapContainer>
				<MapHolder>
					<StoryPlacesMap places={places} />
				</MapHolder>
			</MapContainer>
		</>
	);
};

export default Map;
